import React from 'react';
import { Link } from 'react-router-dom';
import './LegalPage.css';

export default function TermsAndConditions() {
  return (
    <div className="legal">
      <div className="legal__inner">
        <Link to="/" className="legal__brand display" aria-label="Bella 7 home">
          Bella <em>7</em>
        </Link>

        <div className="legal__head">
          <span className="mono legal__kicker">Last updated · {new Date().toLocaleDateString()}</span>
          <h1 className="display legal__heading">Terms &amp; <em>conditions</em>.</h1>
          <p className="legal__intro">
            A few simple rules so we're on the same page about bookings,
            cancellations, and how we run the studio.
          </p>
        </div>

        <section className="legal__section">
          <h2>Bookings</h2>
          <p>
            Booking through this site reserves a chair for you at the date
            and time you select. You'll receive a confirmation email
            immediately and a reminder the day before.
          </p>
        </section>

        <section className="legal__section">
          <h2>Cancellations &amp; rescheduling</h2>
          <p>
            Cancellations are free up to 24 hours before your appointment.
            Please reach out as early as you can if your plans change so we
            can offer the slot to someone else.
          </p>
        </section>

        <section className="legal__section">
          <h2>No-shows</h2>
          <p>
            If you miss your appointment without letting us know, we may ask
            for a small deposit before booking your next visit.
          </p>
        </section>

        <section className="legal__section">
          <h2>Late arrivals</h2>
          <p>
            We hold appointments for up to 15 minutes past the start time.
            After that we may need to reschedule so the next guest isn't
            kept waiting.
          </p>
        </section>

        <section className="legal__section">
          <h2>Service results</h2>
          <p>
            We do our best to match the look you're going for, but results
            depend on hair condition, prior treatments, and other factors
            outside our control. We'll talk through realistic outcomes
            before any major service.
          </p>
        </section>

        <section className="legal__section">
          <h2>Pricing</h2>
          <p>
            Prices are confirmed before the service begins. Add-ons or
            extra time may adjust the final price — we'll always check in
            with you before adding anything.
          </p>
        </section>

        <section className="legal__section">
          <h2>Questions</h2>
          <p>
            Anything unclear? Send us a note through the
            <Link to="/#contact"> contact form </Link>
            and we'll happily walk through it.
          </p>
        </section>

        <Link to="/" className="legal__back">← Back to home</Link>
      </div>
    </div>
  );
}